export default __webpack_public_path__ + "static/smsc_bucket_hat_1-1f2f6b5bd2f0757ae698099cbced27c1.png";